export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_09_PowerScaleOneFS-end.e922b8a5.jpg";